import { getTalents } from '@/contentful/getTalent'
import Talent from '@/src/components/Talent'
import { setMetaTags } from '@/src/components/utils/manage-tags'
import { findTalentBySlug } from '@/src/components/utils/search-controls'
import Head from 'next/head'
import { useRouter } from 'next/router'

export const getServerSideProps = async (context: any) => {

    const talents = await getTalents()
    const talent = findTalentBySlug(talents, context.params.slug) as any
    if (!talent) return { notFound: true }

    const host = context.req.headers.host
    
    return {
        props: {
            host,
            talent,
            talents,
        },
    }
}

export default function TalentPage({ host, talent, talents }: any) {
    const router = useRouter()
    return (
        <>
            <Head>
                {setMetaTags(host, { talent: talent }, router.asPath)}
            </Head>
            <Talent talents={talents} talent={talent} />
        </>
    )
}
